export const hasFilesLabel = "hOgKkc";
export const hasCalendarInviteLabel = "XZ8tQe";
export const highPriorityFilterLabel = "wWWf$";
export default {hasFilesLabel,hasCalendarInviteLabel,highPriorityFilterLabel};